import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import FormRadio from "@ats/src/components/forms/FormRadio";

interface RadioOption {
  value: string;
  label: string;
  description?: string;
  disabled?: boolean;
}

interface Props {
  name: string;
  options: RadioOption[];
  value: string;
  onChange: (name, value) => void;
  disabled?: boolean;
  direction?: "row" | "column";
}

const FormRadioGroup: React.FunctionComponent<Props> = ({
  name,
  options,
  value,
  onChange,
  disabled = false,
  direction = "row",
}) => {
  const Group = direction === "column" ? Styled.ColumnGroup : Styled.RowGroup;

  return (
    <Group role="radiogroup">
      {options.map((option) => (
        <FormRadio
          key={option.value}
          id={`${name}-${option.value}`}
          name={name}
          value={option.value}
          checked={value === option.value}
          onChange={(nextValue) => onChange(name, nextValue)}
          label={option.label}
          description={option.description}
          disabled={disabled || option.disabled}
        />
      ))}
    </Group>
  );
};

export default FormRadioGroup;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.RowGroup = styled.div((props: any) => {
  const t: any = props.theme;
  return css`
    label: FormRadioGroup_RowGroup;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0 ${t.spacing[5]};
  `;
});

Styled.ColumnGroup = styled.div`
  label: FormRadioGroup_ColumnGroup;
  display: flex;
  flex-direction: column;
`;
